module.exports = __webpack_public_path__ + "img/keyichugong.e8899f55.png";